import DefaultLayout from 'components/layout/DefaultLayout';
import OtrixPlayHome from 'components/play/OtrixPlayHome';
import PlayExercisesPage from 'components/play/PlayExercisesPage';
import WeeklyRoutineBuilder from 'components/play/WeeklyRoutineBuilder';
import PlayWorkoutRunner from 'components/play/PlayWorkoutRunner';
import SharedRoutinesForum from 'components/play/SharedRoutinesForum';
import PlayMyRankPage from 'components/play/PlayMyRankPage';
import PlayPerformanceHistory from 'components/play/PlayPerformanceHistory';
import routes from 'common/routes';
import { roles } from 'common/constants/options';

const playRoutes = [
  {
    key: 'otrix-play-home',
    exact: true,
    path: routes.otrixPlayHome.path,
    component: OtrixPlayHome,
    layout: DefaultLayout,
    allowedRoles: [roles.client],
    requiresMembership: true,
    allowedPlatforms: ['otrix_play']
  },
  {
    key: 'play-exercises',
    exact: true,
    path: routes.playExercises.path,
    component: PlayExercisesPage,
    layout: DefaultLayout,
    allowedRoles: [roles.client],
    requiresMembership: true,
    allowedPlatforms: ['otrix_play']
  },
  {
    key: 'play-routine',
    exact: true,
    path: routes.playRoutine.path,
    component: WeeklyRoutineBuilder,
    layout: DefaultLayout,
    allowedRoles: [roles.client],
    requiresMembership: true,
    allowedPlatforms: ['otrix_play']
  },
  {
    key: 'play-workout',
    exact: true,
    path: routes.playWorkout.path,
    component: PlayWorkoutRunner,
    layout: DefaultLayout,
    allowedRoles: [roles.client],
    requiresMembership: true,
    allowedPlatforms: ['otrix_play']
  },
  {
    key: 'play-forum',
    exact: true,
    path: routes.playForum.path,
    component: SharedRoutinesForum,
    layout: DefaultLayout,
    allowedRoles: [roles.client],
    requiresMembership: true,
    allowedPlatforms: ['otrix_play']
  },
  {
    key: 'play-my-rank',
    exact: true,
    path: routes.playMyRank.path,
    component: PlayMyRankPage,
    layout: DefaultLayout,
    allowedRoles: [roles.client],
    requiresMembership: true,
    allowedPlatforms: ['otrix_play']
  },
  {
    key: 'play-performance',
    exact: true,
    path: routes.playPerformance.path,
    component: PlayPerformanceHistory,
    layout: DefaultLayout,
    allowedRoles: [roles.client],
    requiresMembership: true,
    allowedPlatforms: ['otrix_play']
  }
];

export default playRoutes;
